import { useEffect, useState } from "react";
import { getBusinessOpenStatus } from "@/lib/businessHours";

export function useBusinessOpenStatus(business: any) {
  // We do not need to read tick.
  // Updating it is enough to force this hook/component to re-render every minute.
  const [, setTick] = useState(0);

  useEffect(() => {
    let interval: ReturnType<typeof setInterval> | null = null;

    const now = new Date();

    const msToNextMinute =
      (60 - now.getSeconds()) * 1000 - now.getMilliseconds();

    const timeout = setTimeout(() => {
      setTick((v) => v + 1);

      interval = setInterval(() => {
        setTick((v) => v + 1);
      }, 60 * 1000);
    }, Math.max(500, msToNextMinute));

    return () => {
      clearTimeout(timeout);

      if (interval) {
        clearInterval(interval);
      }
    };
  }, []);

  return getBusinessOpenStatus(business);
}